<template>
  <iframe src="/addyourface/index.html" frameborder="0" allow="camera"></iframe>
</template>

<script>
export default {
  name: 'AddFace',

  mounted() {
    window.addEventListener('message', () => {
      if (event.data === 'loadingError') {
        this.$router.push('/loading-error');
      }
    });

    this.$el.on('load', () => {
      this.$el.focus();
    });
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
  iframe {
    position: absolute;
    width: 100%;
    height: 100vh;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/AddFace.vue